import React, { createContext } from 'react';

import { GetFiscalYearQuery, MonthYearPeriod, PeriodName, ProductType } from '@neo.tax/shared';

import { AscContextType } from './asc-context-provider.types';

export const AscContext = createContext<AscContextType>({
  fiscalYearId: undefined,
  fiscalYear: undefined,
  periodName: undefined,
  period: undefined,
  product: undefined,
});

type AscContextProviderProps = {
  children?: React.ReactNode;
  fiscalYearId: string;
  fiscalYear: GetFiscalYearQuery['getFiscalYear'];
  periodName: PeriodName;
  period: MonthYearPeriod;
  product: ProductType;
};

export const AscContextProvider = ({
  children,
  fiscalYear,
  fiscalYearId,
  period,
  periodName,
  product,
}: AscContextProviderProps): React.ReactElement => (
  <AscContext.Provider value={{ fiscalYearId, fiscalYear, periodName, period, product }}>
    {children}
  </AscContext.Provider>
);
